<template>
  <a-modal
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="md-data-formModal items-no-padding fullscreen"
    spacer
    v-model="isFormModalActiveLocal"
  >
    <div class="mt-4 flex items-center justify-between px-6">
      <h4>
        {{ title }}
      </h4>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component
      :is="scrollbarTag"
      class="scroll-area--md-form"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <vs-row vs-w="12">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
          >
            <vs-input
              class="mt-5 w-full ml-1"
              label="제목"
              v-model="tempData['title']"
            />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
          >
            <div class="mt-5 w-full ml-1">
              <label class="vs-input--label">내용</label>
              <vue-editor class="mt-5 w-full ml-1" v-model="tempData['msg']" />
            </div>
          </vs-col>
        </vs-row>
        <small v-if="tempData['eventdttm']">
          생성일 {{ getFormatDate(tempData["eventdttm"]) }}
        </small>
        <br />
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" v-if="!isNew" color="danger" @click="deleteData"
        >삭제</vs-button
      >
      <vs-button
        class="mr-6 button-position-right"
        type="border"
        color="danger"
        @click="isFormModalActiveLocal = false"
        >취소</vs-button
      >
      <vs-button
        class="button-position-right"
        style="margin-right: 8rem"
        @click="submitData"
        :disabled="!isFormValid"
        >저장</vs-button
      >
    </div>
  </a-modal>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import { VueEditor } from "vue2-editor"
import { getFormatDate } from "@/views/components/fnc.js"

export default {
  props: {
    isFormModalActive: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: () => ""
    },
    data: {
      type: Object,
      default: () => {}
    },
    columns: {
      type: Array,
      default: () => []
    }
  },
  components: {
    VuePerfectScrollbar,
    VueEditor
  },
  data () {
    return {
      tempData: {
        title: "",
        msg: "",
        eventdttm: ""
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    }
  },
  watch: {
    isFormModalActive (val) {
      if (!val) return
      this.initValues()
      this.$validator.reset()

      this.tempData = { ...this.tempData, ...this.data }

      // if new
      if (!this.data.doc_id) {
        this.columns.forEach(column => {
          this.tempData[column.key] = ""
        })
      }
    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    isNew () {
      return !((this.data.doc_id && true) || false)
    },
    isFormModalActiveLocal: {
      get () {
        return this.isFormModalActive
      },
      set (val) {
        if (!val) {
          this.$emit("closeFormModal")
        }
      }
    },
    isFormValid () {
      for (const i in this.columns) {
        const column = this.columns[i]
        if (column.custom.required) {
          if (!this.tempData[column.key]) {
            return false
          }
        }
      }
      return true
    },
    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    initValues () {
      if (this.data.doc_id) return
      this.columns.forEach(column => {
        this.tempData[column.key] = ""
      })
    },
    getFormatDate (date) {
      return getFormatDate(date)
    },
    async syncDialog ({ type, color, title, text }) {
      return new Promise(async resolve => {
        this.$vs.dialog({
          type,
          color,
          title,
          text,
          accept: () => {
            resolve(true)
          },
          acceptText: "확인",
          cancel: () => {
            resolve(false)
          },
          cancelText: "취소"
        })
      })
    },
    async submitData () {
      const process = await this.syncDialog({
        type: "confirm",
        color: "primary",
        title: "저장",
        text: "저장하시겠습니까?"
      })
      if (process) {
        this.$vs.loading()
        // update
        if (this.data.doc_id) {
          this.tempData.doc_id = this.data.doc_id
          this.$emit("update", this.tempData)
          // insert
        } else {
          this.$emit("insert", this.tempData)
        }
        this.$vs.loading.close()
        this.$emit("closeFormModal")
        this.initValues()
      }
    },
    async deleteData () {
      let process = false
      process = await this.syncDialog({
        type: "alert",
        color: "danger",
        title: "데이터 삭제",
        text: "데이터 삭제를 진행합니까?"
      })

      if (process) {
        // // delete
        this.$emit("delete", this.data)
        this.$emit("closeFormModal")
        this.initValues()
      }
    },
    onSelect (column, val) {
      this.tempData[column.key] = val
    },
    onOpenHistory () {
      this.$emit("openHistory")
    }
  }
}
</script>

<style lang="scss" scoped>
.md-data-formModal {
  ::v-deep .a-modal--background {
    z-index: 52010;
  }

  ::v-deep .a-modal {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--md-form {
  height: calc(var(--vh, 1vh) * 80 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>